export const infobankTypes = [
    "Emergency Contacts",
    "Medical Records",
    "Vaccination Records",
    "Allergy Information",
    "Prescription Medications",
    "Family Medical History",
    "Pediatrician Contacts",
    "School Information",
    "Attendance Records",
    "Parent-Teacher Conference Notes",
    "Homework Tracker",
    "School Project Deadlines",
    "Meal Plans",
    "Childcare Provider Info",
    "Sleep Schedules",
    "Growth and Development Milestones",
    "Parental Permissions and Consent Forms",
    "Behavioral Reports",
    "Sports and Extracurricular Activities",
    "After-School Program Info",
    "Speech Therapy Progress",
    "Mental Health Records",
    "Family Calendar",
    "Travel Plans",
    "Legal Documents",
    "Insurance Details",
    "Hospital Visits History",
    "Tutoring Schedule",
    "Emergency Plans",
    "Carpool Arrangements",
    "Sleepover Info",
    "Vacation Planning",
    "Sibling Care Schedule",
    "Sitter Instructions",
    "Academic Progress",
    "Potty Training Tracker",
    "Child Developmental Reports",
    "Special Needs Resources",
    "Allowance/Budget Tracker",
    "Custody Schedules",
    "Chore Lists",
    "Sports and Extracurricular Fees",
    "Friend Contact List",
    "Favorite Books and Toys",
    "Discipline Logs",
    "Screen Time Log",
    "Family Traditions and Rituals",
    "Volunteer and Community Activities",
    "Birthday Party Planning",
    "Event Invitations",
    "Internet Safety Rules",
    "Parental Notes"
  ];
  